import React from 'react'
import { withStyles } from '@material-ui/core'
import { Translation, useTranslation } from 'react-i18next'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import {
  FormatEmails,
  FormatIndustries
} from '../../../utils/employer/stringArrayHandle.utils'

const styles = (theme) => ({
  body: {
    margin: 0,
    fontFamily: 'Poppins, sans-serif',
    backgroundColor: 'white',
    padding: '10px',
    fontSize: 14,
    overflowX: 'auto',
    marginBottom: 10,
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px'
    }
  },
  tbody: {
    textAlign: 'left'
  },
  tabledata: {
    color: 'black',
    marginTop: '10px'
  },
  quarterWidth: {
    width: '20%',
    [theme.breakpoints.down('sm')]: {
      width: 'auto'
    }
  }
})

const newAssignmentPreview = ({
  classes,
  assignmentFormValues,
  closePreviewNewAssignment,
  emails
}) => {
  const { t } = useTranslation()
  const allEmails = emails.map((e) => e.email)
  const favoriteEmails = emails
    .filter((e) => e.pinned_fav_lightentrepreneur)
    .map((e) => e.email)

  const assignmentType = assignmentFormValues.assignmentType
  const salaryModel = assignmentFormValues.salaryModel

  const showHourlyRate =
    (assignmentType !== '' && salaryModel === 'hourly_rate') ||
    (assignmentType === 'until_completion' && salaryModel === 'commission')

  const showWeeklyHours =
    assignmentType !== '' &&
    (salaryModel === 'hourly_rate' || salaryModel === 'commission')

  const showAmount_e =
    (assignmentType === 'until_further_notice' &&
      salaryModel === 'contract_price') ||
    (assignmentType === 'temporary' && salaryModel === 'contract_price') ||
    (assignmentType === 'temporary' && salaryModel === 'commission')

  const showAmount_e_pct_pc =
    (assignmentType === 'until_further_notice' &&
      salaryModel === 'unit_price') ||
    (assignmentType === 'temporary' && salaryModel === 'unit_price')

  const showAssignmentEnds =
    assignmentType === 'temporary' && salaryModel !== ''

  const showContractSalary =
    salaryModel === 'contract_price' ||
    (assignmentType === 'until_completion' && salaryModel === 'contract_price')

  const showUnitPrice =
    salaryModel === 'unit_price' ||
    (assignmentType === 'until_completion' && salaryModel === 'unit_price')

  const showAmount_salary_e_pct =
    assignmentType === 'until_further_notice' && salaryModel === 'commission'

  let employmenttype = [
    assignmentFormValues.weekdays && t('employer.assignments.label8a'),
    assignmentFormValues.morning && t('employer.assignments.label8c'),
    assignmentFormValues.evening && t('employer.assignments.label8e'),
    assignmentFormValues.night && t('employer.assignments.label8b'),
    assignmentFormValues.weekends && t('employer.assignments.label8d'),
    assignmentFormValues.remote && t('employer.assignments.label8f'),
    assignmentFormValues.undefined_hours && t('employer.assignments.label8g')
  ]
    .filter(Boolean)
    .join(', ')

  // Convert assignment type and salary model to text
  const salary_model =
    assignmentFormValues.salaryModel === 'hourly_rate'
      ? 1
      : assignmentFormValues.salaryModel === 'contract_price'
      ? 2
      : assignmentFormValues.salaryModel === 'unit_price'
      ? 3
      : assignmentFormValues.salaryModel === 'commission'
      ? 4
      : ''

  const assignment_type =
    assignmentFormValues.assignmentType === 'until_further_notice'
      ? 1
      : assignmentFormValues.assignmentType === 'temporary'
      ? 2
      : assignmentFormValues.assignmentType === 'temporary_with_notice'
      ? 3
      : assignmentFormValues.assignmentType === 'until_completion'
      ? 4
      : ''

  const offer_to_e_email = assignmentFormValues?.offer_to_e_email
    ? assignmentFormValues.offer_to_e_email
    : []
  const offer_to_industry = assignmentFormValues.offer_to_industry ?? []

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <div style={{ padding: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ margin: 'auto' }}>
                  <h3 style={{ fontSize: '18px' }}>
                    {t('employer.previewA.h1')}
                  </h3>
                </div>
                <div className="link">
                  <FontAwesome
                    name="window-close"
                    style={{
                      color: '#F67131'
                    }}
                    size="lg"
                    onClick={() => {
                      closePreviewNewAssignment()
                    }}
                  />
                </div>
              </div>
              <div style={{ textAlign: 'center' }}>
                {t('employer.previewA.p')}
              </div>
            </div>

            <div className="table-box">
              <div className={classes.body}>
                <table>
                  <tbody className={classes.tbody}>
                    <tr className="tableRow">
                      <th colSpan={3}>
                        {offer_to_e_email.length === 1 &&
                        offer_to_e_email[0] === '' ? (
                          ''
                        ) : (
                          <>
                            <span>{t('employer.previewA.col12')}</span>
                            <p className={classes.tabledata}>
                              {renderEmail(
                                offer_to_e_email,
                                t,
                                allEmails,
                                favoriteEmails,
                                emails
                              )}
                            </p>
                          </>
                        )}
                      </th>
                    </tr>

                    <tr className="tableRow">
                      <th>
                        <span>{t('employer.previewA.col1')}</span>
                        <p className={classes.tabledata}>
                          {assignmentFormValues.jobTitle}
                        </p>
                      </th>
                      <th colSpan={2}>
                        <span>{t('employer.previewA.col2')}</span>
                        <p className={classes.tabledata}>
                          <FormatIndustries
                            industryList={offer_to_industry.map((el) =>
                              t(`employer.areaOfWork.${el}`)
                            )}
                            t={t}
                          />
                        </p>
                      </th>
                      <th>
                        <span>{t('employer.previewA.col3')}</span>
                        <p className={classes.tabledata}>
                          {assignmentFormValues.location}
                        </p>
                      </th>
                    </tr>
                    <tr className="tableRow">
                      <th>
                        <span>{t('employer.previewA.col5')}</span>
                        <p className={classes.tabledata}>
                          {t(`employer.assignmentType.${assignment_type}`)}
                        </p>
                      </th>
                      <th>
                        <span>{t('employer.previewA.col8')}</span>
                        <p className={classes.tabledata}>
                          {moment(assignmentFormValues.assignmentBegin).format(
                            'DD.MM.YYYY'
                          )}
                        </p>
                      </th>
                      <th>
                        <span>{t('employer.previewA.col17')}</span>
                        <p className={classes.tabledata}>
                          {showAssignmentEnds
                            ? moment(
                                assignmentFormValues.assignmentEnds
                              ).format('DD.MM.YYYY')
                            : '--.--.----'}
                        </p>
                      </th>
                      <th>
                        <span>{t('employer.previewA.col7')}</span>
                        <p className={classes.tabledata}>{employmenttype}</p>
                      </th>
                    </tr>
                    <tr className="tableRow">
                      <th className={classes.quarterWidth}>
                        <span>{t('employer.previewA.col4')}</span>
                        <p className={classes.tabledata}>
                          {t(`employer.salaryModel.${salary_model}`)}
                        </p>
                      </th>
                      <th className={classes.quarterWidth}>
                        <span>{t('employer.previewA.col6')}</span>
                        <p className={classes.tabledata}>
                          {moment(assignmentFormValues.lastDate).format(
                            'DD.MM.YYYY'
                          )}
                        </p>
                      </th>
                      <th className={classes.quarterWidth}>
                        <span>{t('employer.previewA.col19')}</span>
                        <p className={classes.tabledata}>
                          {assignmentFormValues.manualNotice}
                        </p>
                      </th>
                      <th className={classes.quarterWidth}>
                        <span style={{ display: 'flex', gap: '30px' }}>
                          {showHourlyRate ? (
                            <span>
                              <span>{t('employer.previewA.col13')}</span>
                              <p className={classes.tabledata}>
                                {assignmentFormValues.hourlyRate}
                              </p>
                            </span>
                          ) : showAmount_e ? (
                            <span>
                              <span>{t('employer.previewA.col15')}</span>
                              <p className={classes.tabledata}>
                                {assignmentFormValues.amount_e}
                              </p>
                            </span>
                          ) : showAmount_e_pct_pc ? (
                            <span>
                              <span>{t('employer.previewA.col18')}</span>
                              <p className={classes.tabledata}>
                                {assignmentFormValues.amount_e}
                              </p>
                            </span>
                          ) : showContractSalary ? (
                            <span>
                              <span>{t('employer.previewA.col20')}</span>
                              <p className={classes.tabledata}>
                                {assignmentFormValues.contractSalary}
                              </p>
                            </span>
                          ) : showUnitPrice ? (
                            <span>
                              <span>{t('employer.previewA.col21')}</span>
                              <p className={classes.tabledata}>
                                {assignmentFormValues.unitPrice}
                              </p>
                            </span>
                          ) : showAmount_salary_e_pct ? (
                            <span>
                              <span>{t('employer.previewA.col16')}</span>
                              <p className={classes.tabledata}>
                                {assignmentFormValues.amount_e}
                              </p>
                            </span>
                          ) : null}
                          <span>
                            <span>{t('employer.previewA.col14')}</span>
                            {showWeeklyHours ? (
                              <p className={classes.tabledata}>
                                {assignmentFormValues.weeklyHours}
                              </p>
                            ) : null}
                          </span>
                        </span>
                      </th>
                    </tr>
                    <tr className="tableRow">
                      <th colSpan={4}>{t('employer.previewA.col11')}</th>
                    </tr>
                    <tr
                      className="tableRow-info"
                      style={{ verticalAlign: 'top' }}
                    >
                      <th
                        className="job-des"
                        colSpan={4}
                        dangerouslySetInnerHTML={{
                          __html: assignmentFormValues.job_des
                        }}
                      />
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

export const renderEmail = (
  selected,
  t,
  allEmails,
  favoriteEmails,
  emailsList
) => {
  const isAll = selected.length === allEmails.length
  const isFavoriteOnly =
    favoriteEmails.every((fav) => selected.includes(fav)) &&
    selected.length === favoriteEmails.length &&
    favoriteEmails.length > 0
  const isFavoritePlus =
    favoriteEmails.every((fav) => selected.includes(fav)) &&
    selected.length > favoriteEmails.length &&
    favoriteEmails.length > 0

  const firstSelectedEmail = emailsList.find((el) => el.email === selected[0])
  const lightEntre = emailsList.filter((el) => selected.includes(el.email))

  if (isAll) return t('employer.assignments.render1')
  if (isFavoriteOnly) return t('employer.assignments.render2')
  if (isFavoritePlus) return t('employer.assignments.render3')
  if (selected.length === 1)
    return `${firstSelectedEmail.firstname} ${firstSelectedEmail.lastname}`
  if (selected.length > 1)
    return <FormatEmails emails={selected} lightEntreList={lightEntre} t={t} />

  return ''
}

export default withStyles(styles)(newAssignmentPreview)
